/****************************************************
 * Module Name:  igiMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import Accordion from "react-bootstrap/Accordion";
import WorkerProxy from "../../utility/proxy/worker/workerProxy";
import AddCertificateModal from "./addCertificateModal";
import ShowLabStatsModal from "./showLabStatsModal";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import TextField from "@mui/material/TextField";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect } from "react";
import Utility from "../../utility/utility";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import { Box, Button, Tooltip } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import renderCellExpand from "../common/dataGridCellExpand";
import Select from "react-select";
import CommonSnackbar from "../common/commonSnackBar";
import Constants from "../../utility/constants";
import NoPermission from "../common/noPermission";
import CommonStoneSelection from "../common/commonStoneSelection";
import { ApprovalOutlined } from "@mui/icons-material";
import { Modal } from "react-bootstrap";
import logo from "../../images/pansuriya.jpg";
import { LoadingButton } from "@mui/lab";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { MdOutlineMoveUp } from "react-icons/md";
import WorkersettingsProxy from "../../utility/proxy/worker/workersettingsProxy";
import PageTitle from "../common/pageTitle";

function IgiMaster() {
  const statusOptions = [
    { value: "NEW", label: "NEW" },
    { value: "FAILED", label: "FAILED" },
    { value: "PROCESSED", label: "PROCESSED" },
    { value: "RETRY", label: "RETRY" },
    { value: "IN_PROGRESS", label: "IN_PROGRESS" },
    { value: "LATER", label: "LATER" },
    { value: "PARK1", label: "PARK1" },
    { value: "PARK2", label: "PARK2" },
    { value: "PARK3", label: "PARK3" },
  ];
  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [certificateId, setCertificateId] = useState("");
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [igiLoader, setIgiLoader] = useState(false);
  const [formData, setFormData] = useState({
    fromDate: "",
    toDate: "",
    status: statusOptions.filter((s) => (s.value === "LATER"))[0],
    limit: "",
  });
  const [selectionModel, setSelectionModel] = useState([]);
  const [showMoveToModal, setShowMoveToModal] = useState(false);
  const [showChangePriorityModal, setShowChangePriorityModal] = useState(false);
  const [selectedMoveToStatus, setSelectedMoveToStatus] = useState(false);
  const [changedPriority, setChangedPriority] = useState(null);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [access, setAccess] = useState(false);

  const [showStats, setShowStats] = useState(false);
  const [labStats, setLabStats] = useState([]);
  const [showStatsError, setShowStatsError] = useState(false);
  const [columns, setColumns] = useState([]);
  const [filterValues, setFilterValues] = useState({});
  const [moveToLoader, setMoveToLoader] = useState(false);

  // eslint-disable-next-line
  const [local_Permission, setLocal_Permission] = useState(
    Constants.USER_PERMISSION.filter(
      (iPermission) =>
        iPermission.permissionid === Constants.PERMISSIONS.WORKER_IGI
    )
  );

  useEffect(() => {
    PageTitle("WORKER_IGI");
    checkPermission();
    getDefaultLimitValue();
  }, []);

  const getDefaultLimitValue = () => {
    const settingKey = "IGI_PROCESSING_BATCH";
    WorkersettingsProxy.GetSingleWorkersetting(settingKey, response => {
      if (response && response.settingvalue && response.settingvalue !== "") {
        setFormData({
          ...formData,
          limit: parseInt(response.settingvalue)
        });
      }
    });
  }

  useEffect(() => {
    const localStorageKey = `${window.location.pathname.split('/').pop()}_ColumnOrder`;
    const savedColumnOrder = JSON.parse(localStorage.getItem(localStorageKey));

    const originalColumns = initialColumns();
    Utility.applySavedColumnOrder(savedColumnOrder, originalColumns, setColumns);
  }, [data]);

  const checkPermission = () => {
    let allowed = Utility.isReadAllowed(local_Permission)
    if (!allowed) {
      setAccess(true)
      return <NoPermission />
    }
    else {
      setFormData({
        ...formData,
        fromDate: '',
        toDate: '',
      });
    }
  }

  const fetchhandler = (certificateId) => {
    let { fromDate, toDate, limit, status } = formData;
    let lCertificateId = certificateId !== null && certificateId.trim() !== '' ? certificateId.replaceAll(' ', "").split(',').filter((c) => c.trim() !== '') : [];

    setIgiLoader(true);
    let uStartTime = "";
    let uEndTime = "";
    if (fromDate !== null && fromDate !== '') {
      uStartTime = Utility.ConvertLocalTimeToUtc(fromDate);
    }
    if (toDate !== null && toDate !== '') {
      uEndTime = Utility.ConvertLocalTimeToUtc(toDate);
    }
    WorkerProxy.GetFilteredIgi(
      status.value,
      uStartTime,
      uEndTime,
      limit,
      lCertificateId,
      (responseData) => {
        if (responseData) {
          const uniqueFilterValues = {
            clarity: Utility.getDistinctOptions(responseData, "clarity"),
            shape: Utility.getDistinctOptions(responseData, "shape"),
            culteSize: Utility.getDistinctOptions(responseData, "culteSize"),
            intensityLongtitle: Utility.getDistinctOptions(responseData, "intensityLongtitle"),
            gridleMin: Utility.getDistinctOptions(responseData, "gridleMin"),
            note: Utility.getDistinctOptions(responseData, "note"),
            cut: Utility.getDistinctOptions(responseData, "cut"),
            polish: Utility.getDistinctOptions(responseData, "polish"),
            symmetry: Utility.getDistinctOptions(responseData, "symmetry"),
            color: Utility.getDistinctOptions(responseData, "color"),
            status: Utility.getDistinctOptions(responseData, "status"),
            cutpolsym: Utility.getDistinctOptions(responseData, "cutpolsym"),
          };
          setFilterValues(uniqueFilterValues);
          setData(responseData);
          setIgiLoader(false);
          setSelectionModel([]);
        } else {
          setErrorSnackbar(true)
          setIgiLoader(false);
        }
      }
    );
  };

  const addCertificate = (certificateIds, priority, ids, forceReFetch) => {
    setCertificateId(ids);
    setFormData({ ...formData, fromDate: null, toDate: null });
    setLoadingButton(true);

    WorkerProxy.AddIgiCertificate(certificateIds, priority, forceReFetch, (responseData) => {
      if (responseData) {
        setData([]);
        setShowSuccessSnackbar(true);
        setLoadingButton(false);
        setShow(false);
      } else {
        setErrorSnackbar(true);
        setLoadingButton(false);
      }
    });
  };

  const handleValidation = (certificateIds) => {
    //TODO do validation if needed here
    return true;
  };

  const handleOpen = () => {
    setShow(!show);
    setShowSuccessSnackbar(false);
  };

  const handleClose = () => {
    setShowSuccessSnackbar(false);
  };

  const handleModalClose = () => {
    setShowMoveToModal(false);
    setShowChangePriorityModal(false);
  };

  const getDataHandler = (e) => {
    e.preventDefault();
    fetchhandler(certificateId);
  };

  const handleSelection = (data) => {
    let value = Utility.StringToIntegerArray(data)
    setSelectionModel([...selectionModel, ...value])
  }

  const handleMoveToAnotherStatus = (selectedMoveToStatus) => {
    setMoveToLoader(true);
    let oldstatus = '';
    let newstatus = selectedMoveToStatus.value;
    data.map((item) => {
      if (selectionModel.includes(item.certificateid)) oldstatus = item.status
      return true;
    })

    WorkerProxy.GetChangeIgiCertificateStatus(
      oldstatus, newstatus, selectionModel,
      (res) => {
        if (res) {
          handleModalClose();
          setShowSuccessSnackbar(true);
          fetchhandler(certificateId);
          setMoveToLoader(false);
        }
      }
    )
  }

  const handleChangedPriority = () => {
    setMoveToLoader(true);

    if (!changedPriority) return;

    WorkerProxy.GetChangeIgiCertificatePriority(changedPriority.value, selectionModel,
      (res) => {
        if (res) {
          setShowSuccessSnackbar(true);
          fetchhandler(certificateId);
        } else {
          setErrorSnackbar(true);
        }
        handleModalClose();
        setMoveToLoader(false);
      }
    )
  }

  const initialColumns = () => [
    {
      field: "id",
      headerName: "ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 50,
    },
    {
      field: "userid",
      hheaderName: "USER ID",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 50,
    },
    {
      field: "certificateid",
      headerName: "CERT",
      headerAlign: "center",
      align: "center",
      width: 100,
      renderCell: renderCellExpand,
    },
    {
      field: "priority",
      headerName: "PRIORITY",
      headerAlign: "center",
      align: "center",
      type: "number",
      valueFormatter: (params) => params.value,
      minWidth: 50,
    },
    {
      field: "cut",
      headerName: "CUT",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.cut : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "polish",
      headerName: "POL",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.polish : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "symmetry",
      headerName: "SYM",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.symmetry : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "clarity",
      headerName: "CLARITY",
      headerAlign: "center",
      align: "center",
      width: 130,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.clarity : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "color",
      headerName: "COLOR",
      headerAlign: "center",
      align: "center",
      width: 105,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.color : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "shape",
      headerName: "SHAPE",
      headerAlign: "center",
      align: "center",
      width: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.shape : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "size",
      headerName: "SIZE",
      headerAlign: "center",
      align: "right",
      width: 40,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: (params) => params.value ? Utility.ConvertNumberWithSpecifiedDigits(parseFloat(params.row.size)) : null
    },
    {
      field: "status",
      headerName: "STATUS",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.status : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "comment",
      headerName: "COMMENT",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      renderCell: renderCellExpand,
    },
    {
      field: "createdat",
      headerName: "CREATED AT",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "crownHeight",
      headerName: "CR.HEIGHT",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "culteSize",
      headerName: "CULET SZ",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.culteSize : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "depthPercent",
      headerName: "DEPTH%",
      headerAlign: "center",
      align: "center",
      width: 75,
      renderCell: renderCellExpand,
    },
    {
      field: "gridleMin",
      headerName: "GIRDLEMIN",
      headerAlign: "center",
      align: "center",
      minWidth: 170,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.gridleMin : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "intensityLongtitle",
      headerName: "INTENSITYLONGTITLE",
      headerAlign: "center",
      align: "center",
      minWidth: 120,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.intensityLongtitle : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "laserincription",
      headerName: "INS",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: renderCellExpand,
    },
    {
      field: "measurements",
      headerName: "MEASUREMENTS",
      headerAlign: "center",
      align: "center",
      width: 140,
      renderCell: renderCellExpand,
    },
    {
      field: "note",
      headerName: "NOTE",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.note : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "pavilionDepth",
      headerName: "PV.DEPTH",
      headerAlign: "center",
      align: "center",
      minWidth: 180,
      renderCell: renderCellExpand,
    },
    {
      field: "reportdate",
      headerName: "REPORT DATE",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
    {
      field: "cutpolsym",
      headerName: "CUTPOLSYM",
      headerAlign: "center",
      align: "center",
      width: 100,
      type: "singleSelect",
      valueOptions: filterValues ? filterValues.cutpolsym : [],
      filterOperators: Utility.combinedFilters(),
      renderCell: renderCellExpand,
    },
    {
      field: "tablepercent",
      headerName: "TABLE%",
      headerAlign: "center",
      align: "center",
      width: 75,
      type: "number",
      valueFormatter: (params) => params.value,
      renderCell: renderCellExpand,
    },
    {
      field: "updatedat",
      headerName: "Update Date",
      headerAlign: "center",
      align: "center",
      minWidth: 190,
      type: "dateTime",
      valueGetter: (params) => {
        if (params.value) {
          return new Date(params.value);
        }
        return null;
      },
      renderCell: (params) => Utility.ConvertUtcToLocalTime(params.value),
    },
  ];

  const rows = data;
  const finalColumns = Utility.isUpdateAllowed(local_Permission)
    ? columns
    : columns.filter((col) => col.field !== "edit");

  const handleShowStats = () => setShowStats(true);

  const getIgiStats = () => {
    setLoadingButton(true);
    WorkerProxy.GetAllIgiStats((response) => {
      if (response) {
        const total = response.reduce((acc, curr) => acc + curr.count, 0);
        const totalObject = { status: "TOTAL", count: total };
        const updatedResponse = [...response, totalObject];
        setLabStats(updatedResponse);
        setLoadingButton(false);
      } else {
        setShowStatsError(true);
        setLoadingButton(false);

      }
    });
  }

  return (
    <div>
      <Box>
        {
          access ? <NoPermission /> : (
            <div>
              <Box className="d-flex flex-row pt-1" style={{ width: "100%" }}>
                {handleValidation ? (
                  <CommonSnackbar
                    show={showSuccessSnackbar}
                    message="Certificates added Successfully"
                    variant={"success"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={handleClose}
                    title="Success"
                  />
                ) : null}

                {showSuccessSnackbar ? (
                  <CommonSnackbar
                    show={showSuccessSnackbar}
                    message="Status Updated Successfully"
                    variant={"success"}
                    autoHide={Constants.SnackBarCloseTimer}
                    handleClose={handleClose}
                    title="Success"
                  />
                ) : null}
                <CommonSnackbar
                  show={errorSnackbar}
                  message={Constants.APiFailErrorMessage}
                  variant={"error"}
                  autoHide={Constants.SnackBarCloseTimer}
                  title={"Error"}
                  handleClose={() => setErrorSnackbar(false)}
                />

                <Box style={{ width: '100%', display: 'flex' }}>
                  <Box className="ms-2" style={{ width: '-webkit-fill-available' }}>
                    <Accordion style={{ marginLeft: 1 }}>
                      <Accordion.Item eventKey="0">
                        <Accordion.Header>Filter IGI Master</Accordion.Header>
                        <Accordion.Body>
                          <Form>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex">
                                  <Form.Label className="mt-2 me-2">FROM</Form.Label>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                      ampm={true}
                                      renderInput={(props) => (
                                        <TextField
                                          fullWidth
                                          {...props}
                                          inputProps={{
                                            ...props.inputProps,
                                            readOnly: true,
                                          }}
                                        />
                                      )}
                                      label="Certificate Created From"
                                      value={formData.fromDate}
                                      inputFormat="DD/MM/YYYY hh:mm:ss a"
                                      onChange={(newValue) => {
                                        setFormData({
                                          ...formData,
                                          fromDate: newValue.$d,
                                        });
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Form.Group>
                              </Box>
                              <Box className="col">
                                {" "}
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2 ms-4">
                                    TO
                                  </Form.Label>
                                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DateTimePicker
                                      ampm={true}
                                      renderInput={(props) => (
                                        <TextField
                                          fullWidth
                                          {...props}
                                          inputProps={{
                                            ...props.inputProps,
                                            readOnly: true,
                                          }}
                                        />
                                      )}
                                      label="Certificate Created To"
                                      value={formData.toDate}
                                      inputFormat="DD/MM/YYYY hh:mm:ss a"
                                      onChange={(newValue) => {
                                        setFormData({
                                          ...formData,
                                          toDate: newValue.$d,
                                        });
                                      }}
                                    />
                                  </LocalizationProvider>
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2">Status</Form.Label>
                                  <Box style={{ width: "100%" }}>
                                    <Select menuPlacement="auto"
                                      blurInputOnSelect={false}
                                      defaultValue={formData.status}
                                      closeMenuOnSelect={true}
                                      menuPortalTarget={document.body}
                                      styles={Constants.Styles}
                                      options={statusOptions}
                                      onChange={(e) =>
                                        setFormData({
                                          ...formData,
                                          status: e,
                                        })
                                      }
                                    />
                                  </Box>
                                </Form.Group>
                              </Box>
                              <Box className="col">
                                <Form.Group className="mb-3 d-flex flex-row">
                                  <Form.Label className="mt-2 me-2 ms-2">
                                    Limit
                                  </Form.Label>
                                  <TextField
                                    type="number"
                                    inputProps={{
                                      inputMode: "numeric",
                                      pattern: "[0-9]*",
                                    }}
                                    placeholder="Enter Limit"
                                    fullWidth
                                    label="Limit"
                                    value={formData.limit}
                                    onChange={(e) =>
                                      setFormData({
                                        ...formData,
                                        limit: e.target.value,
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="row">
                              <Box className="col">
                                <Form.Group
                                  className="mb-3 d-flex flex-row justify-content-between no-wrap"
                                  style={{ width: "100%" }}
                                >
                                  <Box style={{ width: "7%" }}>
                                    <Form.Label className="mt-2">
                                      Certificate ID
                                    </Form.Label>
                                  </Box>
                                  <Box style={{ width: "93%" }}>
                                    <TextField
                                      id="outlined-multiline-static"
                                      label="Enter Certificate ID"
                                      placeholder="Comma seperated Certificate Ids"
                                      multiline
                                      fullWidth
                                      rows={4}
                                      value={certificateId}
                                      onChange={(e) =>
                                        setCertificateId(
                                          Utility.ConvertNewLineToComma(e.target.value)
                                        )
                                      }
                                    />
                                  </Box>
                                </Form.Group>
                              </Box>
                            </Box>
                            <Box className="d-flex justify-content-end flex-nowrap mt-3">
                              <LoadingButton
                                variant="contained"
                                onClick={getDataHandler}
                                loading={igiLoader}
                                loadingPosition="start"
                                startIcon={<ManageSearchIcon />}
                                type="submit"
                              >
                                Get Data
                              </LoadingButton>
                            </Box>
                          </Form>
                        </Accordion.Body>
                      </Accordion.Item>
                    </Accordion>
                  </Box>
                  <Box style={{ width: "250px", marginLeft: '20px', marginTop: '7px' }}>
                    {Utility.isAddAllowed(local_Permission) ? (
                      <Button variant="contained" onClick={handleOpen}>
                        Add Certificates
                      </Button>
                    ) : null}
                    {show && (
                      <AddCertificateModal
                        show={show}
                        setShow={setShow}
                        handleValidation={handleValidation}
                        handleSave={addCertificate}
                        loading={loadingButton}
                        labName={"igi"}
                      />
                    )}
                  </Box>
                  <Box style={{ width: '200px', marginLeft: '20px', marginTop: '7px' }}>
                    <Button variant="contained" onClick={handleShowStats}>
                      Show Stats
                    </Button>
                    {showStats && (
                      <ShowLabStatsModal
                        show={showStats}
                        setShow={setShowStats}
                        handleStats={getIgiStats}
                        labStats={labStats}
                        setLabStats={setLabStats}
                        loading={loadingButton}
                        setLoadingButton={setLoadingButton}
                        labName={"IGI"}
                        showStatsError={showStatsError}
                        setShowStatsError={setShowStatsError}
                      />
                    )}
                  </Box>
                </Box>
              </Box>

              <Box px={1} pt={1}>
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    color: '#000',
                    width: "100%",
                    position: "relative",
                    "& .MuiTablePagination-selectLabel": {
                      marginTop: "15px",
                    },
                    "& .MuiTablePagination-displayedRows": {
                      marginTop: "15px",
                    },
                    "& .css-1jbbcbn-MuiDataGrid-columnHeaderTitle": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    "& .css-cc8tf1": {
                      fontWeight: Constants.defaultFontWeight,
                    },
                    height: "80vh",
                  }}
                >
                  <DataGridPro
                    disableRowSelectionOnClick={true}
                    getRowHeight={() => "auto"}
                    sx={{
                      '& .MuiDataGrid-columnHeader': {
                        color: '#fff',
                        backgroundColor: 'grey',
                      },
                      "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                        py: "4px",
                      },
                      "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                        py: "12px",
                      },
                      "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                        py: "18px",
                      },
                      fontSize: Constants.defaultTableFontSize, fontWeight: Constants.defaultFontWeight,
                    }}
                    density="compact"
                    slots={{ toolbar: GridToolbar }}
                    rows={rows}
                    columns={finalColumns}
                    getRowId={(row) => row.certificateid}
                    checkboxSelection={Utility.isUpdateAllowed(local_Permission) ? true : false}
                    onRowSelectionModelChange={(newSelectionModel) => {
                      setSelectionModel(newSelectionModel);
                    }}
                    rowSelectionModel={selectionModel}
                    onColumnOrderChange={(params) => Utility.handleColumnOrderChange(params, columns, setColumns, window.location.pathname)}
                    loading={igiLoader}
                    initialState={{
                      columns: {
                        columnVisibilityModel: {
                          // Hide columns id, the other columns will remain visible
                          id: false,
                          userid: false,
                        },
                      },
                      pagination: {
                        paginationModel: Constants.pageSize,
                      },
                    }}
                    pageSizeOptions={Constants.pageSizeOptions}
                    pagination
                    slotProps={{
                      toolbar: {
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                  />
                  <Box sx={{
                    position: "absolute",
                    left: "0.4rem",
                    top: "1px"
                  }}>
                    <CommonStoneSelection
                      title={"Enter multiple Certificate Ids"}
                      handleSelection={handleSelection}
                      buttonDisabled={rows.length === 0}
                    />
                  </Box>
                  <Box style={{ position: "absolute", top: 5, right: "270px" }}>
                    {igiLoader ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      <Tooltip title="Reload List">
                        <RefreshOutlinedIcon
                          onClick={() =>
                            fetchhandler(certificateId)
                          }
                          color="primary"
                          fontSize="medium"
                          sx={{ cursor: "pointer" }}
                        />
                      </Tooltip>
                    )}

                    {Utility.isUpdateAllowed(local_Permission) ? (
                      <Tooltip title="Change Priority">
                        <Button
                          variant="outlined"
                          size="small"
                          component="label"
                          sx={{ ml: "5px" }}
                          startIcon={<MdOutlineMoveUp size={16} />}
                          color="success"
                          disabled={!(selectionModel.length > 0 && formData.status.value !== "PROCESSED")}
                          onClick={() => setShowChangePriorityModal(true)}>
                          Change Priority
                        </Button>
                      </Tooltip>
                    ) : null}

                    {Utility.isUpdateAllowed(local_Permission) ? (
                      <Tooltip title="Move To">
                        <Button
                          variant="outlined"
                          size="small"
                          component="label"
                          sx={{ ml: "5px" }}
                          startIcon={<MdOutlineMoveUp size={16} />}
                          color="success"
                          disabled={!(selectionModel.length > 0 && formData.status.value !== "PROCESSED")}
                          onClick={() => setShowMoveToModal(true)}>
                          Move To
                        </Button>
                      </Tooltip>
                    ) : null}

                    {showMoveToModal ?
                      <Modal
                        show={showMoveToModal}
                        onHide={handleModalClose}
                        backdrop="static"
                        keyboard={true}
                        customer="lg"
                        centered
                        enforceFocus={false}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <img
                              src={logo}
                              height="40pt"
                              width="40pt"
                              alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;Move To
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Box sx={{ display: "flex", flex: 1, gap: "10px", alignItems: 'center' }}>
                            <Form.Label>Move To : </Form.Label>
                            <Box style={{ flex: 1 }}>
                              <Select menuPlacement="auto"
                                blurInputOnSelect={false}
                                closeMenuOnSelect={true}
                                menuPortalTarget={document.body}
                                styles={Constants.Styles}
                                options={statusOptions.filter((item) => (
                                  item.value !== '' &&
                                  item.value !== 'PROCESSED' &&
                                  item.value !== formData.status.value
                                ))}
                                onChange={(e) => setSelectedMoveToStatus(e)}
                              />
                            </Box>
                          </Box>
                        </Modal.Body>
                        <Modal.Footer>
                          <LoadingButton
                            loading={moveToLoader}
                            loadingPosition="start"
                            startIcon={<ApprovalOutlined size="large" />}
                            variant="contained"
                            color="info"
                            onClick={() => handleMoveToAnotherStatus(selectedMoveToStatus)}
                            sx={{ mr: 2 }}>
                            Move
                          </LoadingButton>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={handleModalClose}
                            sx={{ mr: 2 }}
                            disabled={moveToLoader}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      : null}

                    {showChangePriorityModal ?
                      <Modal
                        show={showChangePriorityModal}
                        onHide={handleModalClose}
                        backdrop="static"
                        keyboard={true}
                        customer="lg"
                        centered
                        enforceFocus={false}>
                        <Modal.Header closeButton>
                          <Modal.Title>
                            <img
                              src={logo}
                              height="40pt"
                              width="40pt"
                              alt={Constants.COMPANY_SITE}
                            />
                            &nbsp;&nbsp;&nbsp;&nbsp;Change Priority
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Box sx={{ display: "flex", flex: 1, gap: "10px", alignItems: 'center' }}>
                            <Form.Label>Change To : </Form.Label>
                            <Box style={{ flex: 1 }}>
                              <Select menuPlacement="auto"
                                blurInputOnSelect={false}
                                closeMenuOnSelect={true}
                                menuPortalTarget={document.body}
                                styles={Constants.Styles}
                                options={Constants.IGI_PRIORITIES}
                                onChange={(e) => setChangedPriority(e)}
                              />
                            </Box>
                          </Box>
                        </Modal.Body>
                        <Modal.Footer>
                          <LoadingButton
                            loading={moveToLoader}
                            loadingPosition="start"
                            startIcon={<ApprovalOutlined size="large" />}
                            variant="contained"
                            color="info"
                            onClick={() => handleChangedPriority()}
                            sx={{ mr: 2 }}>
                            Save
                          </LoadingButton>
                          <Button
                            variant="contained"
                            color="error"
                            onClick={handleModalClose}
                            sx={{ mr: 2 }}
                            disabled={moveToLoader}>
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      : null}

                  </Box>
                </Box>
              </Box>
            </div>
          )
        }
      </Box>
    </div>
  );
}

export default IgiMaster;
